interface IPermission {
  id: string;
  organizationId: string | null;
  permission: string;
  action: string;
  category: string;
  scope: string;
  isSysAdminOnly: boolean;
  isActive: boolean;
  isArchived: boolean;
  description: string;
  createdDate: Date;
  modifiedDate: Date;
  createdBy: string;
  modifiedBy: string;
}

export class PermissionModel implements IPermission {
  id: string = '';
  organizationId: string | null = null;
  permission: string = '';
  action: string = '';
  category: string = '';
  scope: string = '';
  isSysAdminOnly: boolean = false;
  isActive: boolean = true;
  isArchived: boolean = false;
  description: string = '';
  createdDate: Date = new Date();
  modifiedDate: Date = new Date();
  createdBy: string = '';
  modifiedBy: string = '';

  constructor(props: Partial<IPermission> = {}) {
    Object.assign(this, props);
  }
}
